
import {DataStore, EventStore, MenuStore, ModalStore} from "@/store";
import {Options, Vue} from "vue-class-component";
import {translate} from "@/helpers/locale-helper";
import {CreditModalState} from "@/store/modal";
import LogoMain from '@/components/LogoMain/LogoMain.vue'
import {ITheme, ITranslatable} from "@/models/vimy.models";
import BusEvent from "../../../../shared/js/BusEvent";

@Options({
  components: {
    LogoMain
  },
  props: {},
  emits: []
})
export default class CreditModal extends Vue {
  declare $refs: {
    scrollbar: HTMLElement,
    wrapperScrollbar: HTMLElement,
    logo: HTMLElement
  }

  section: CreditModalState = 'about';
  display: boolean = false;
  credits: ITranslatable<string>[] = [];
  fromBus: boolean = false;

  get btnCloseTitle() {
    return translate(this.$i18n.locale, 'general.modal_close');
  }


  get themes(): ITheme[] {
    return DataStore.themes;
  }

  translate(data: any) {
    return data[this.$i18n.locale];
  }

  showParagraph(paragraph: ITranslatable<string>) {
    return (paragraph as any)[this.$i18n.locale];
  }

  scrollbarHeight() {
    if (!this.$refs.wrapperScrollbar)
      return;

    const totalHeight = this.$refs.wrapperScrollbar.clientHeight;

    // @ts-ignore
    this.$refs.wrapperScrollbar.querySelector(".ps").style.height = totalHeight + 'px';

    // @ts-ignore
    this.$refs.scrollbar.update();
  }

  close(): void {
    this.display = false;
    this.section = 'about';

    document.body.classList.remove('modal-credits-open');
  }

  processBusEvent() {
    const ev = event as BusEvent;
    this.fromBus = true;
    this.display = true;
    this.section = 'credits';
    setTimeout(() => {

      /**
       * Michal, 2022-03-31  Les refs n'étaient pas là...
       * J'essaie de corrigerm, mais les refs dans les refs ne sont pas fins avec moi, alors...
       * ...to the old-school js
       */
      document.querySelector('.credits-page .main-top-logo')?.classList.add('part-2');
    }, 3000);
  }

  mounted() {
    this.$watch('display', (value: boolean, _: boolean) => {
      if (value) {
        EventStore.showFog();
      } else {
        EventStore.hideFog();
      }
    });

    document.addEventListener(BusEvent.EVENTS.SHOW_END_CREDITS, this.processBusEvent.bind(this));
    document.addEventListener(BusEvent.EVENTS.OUTRO_2D_FINISHED, this.processBusEvent.bind(this));

    ModalStore.$watch(t => t.creditOpens, (val, _) => {
      this.section = ModalStore.creditModalState;
      MenuStore.close();
      this.display = true;
    });

    this.credits = DataStore.credits;
    DataStore.$watch(t => t.credits, (value, _) => {
      this.credits = value;
    });

    this.$watch("display", (val: boolean, _: boolean) => {
      if (!val) {
        this.fromBus = false;
        return;
      }

      document.body.classList.add('modal-credits-open');
      setTimeout(this.scrollbarHeight.bind(this), 1000);
    });

    window.addEventListener("resize", this.onResize);
  }

  unmounted() {
    this.section = 'about';

    window.removeEventListener("resize", this.onResize);
  }

  private onResize(event: Event) {
    this.scrollbarHeight();
  }

  createSlug( str : string) : string {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-") // collapse dashes
        .replace(/^-+/, "") // trim - from start of text
        .replace(/-+$/, ""); // trim - from end of text

      return str;
  }
}
